export const formatPercentage = (value: number, decimalPlaces = 0): string => {
  const percentage = value * 100;
  return `${percentage.toFixed(decimalPlaces)}%`;
};
